import { Component, Input } from '@angular/core';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})

export class AlertMessages {
  @Input() errorMsg: string;
  @Input() displayError: boolean;
  @Input() displaySuccess: boolean;
}


// WEBPACK FOOTER //
// ./src/app/shared/alert-message/alert.component.ts